// Imports
import AxiosConfig from './serverAxiosConfig'
import firebase from '../config/FirebaseConfig'

const getBillingDetails = async () => {
  // Pull the current token off the user
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.get(
    '/users/billing',
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

// Churn
const getChurnHash = async (cusId) => {
  const { Aa: token } = firebase.auth().currentUser

  const payload = {
    customerId: cusId
  }
  const { data } = await AxiosConfig.post(
    '/users/churn',
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const validateEmail = async () => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/users/validate-email',
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

const submitOnboardingPersonalization = async (payload) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post(
    '/users/onboard-personalize-info', 
    payload, 
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  )

  return data
}

// FB Auth for lens
const createFBToken = async (accessToken, redirectURI) => {
  const { Aa: token } = firebase.auth().currentUser

  const { data } = await AxiosConfig.post('/users/auth-fb', {
    code: accessToken,
    redirect_uri: redirectURI
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  return data
}

export default {
  getBillingDetails,
  getChurnHash,
  validateEmail,

  createFBToken,
  submitOnboardingPersonalization
}
